// Utils
import createDeepEqualSelector from '../../../../../../../../utils/reselect/createDeepEqualSelector';

const selectDefaultValues = (state, props) => props.defaultValues;

const selectInitialValues = createDeepEqualSelector(
    [selectDefaultValues],
    defaultValuesState => {
        if (defaultValuesState) {
            const {
                entityTypeId,
                payrollCode,
                ...defaultValues
            } = defaultValuesState;
            return {
                ...defaultValues,
                entityTypeId: entityTypeId ? Number(entityTypeId) : undefined,
                payrollCode: payrollCode ? Number(payrollCode) : undefined
            };
        }
        return undefined;
    }
);

export { selectInitialValues };
